import { IArrowBottomTrailerProps } from "interfaces";

const ArrowBottomTrailerIcon = ({ className, onClick }: IArrowBottomTrailerProps) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className}
             onClick={onClick}>
            <path
                d="M4.43997 11.88C4.43997 11.6266 4.53331 11.3733 4.73331 11.1733C5.11997 10.7866 5.75998 10.7866 6.14664 11.1733L14.84 19.8666C15.48 20.5066 16.52 20.5066 17.16 19.8666L25.8533 11.1733C26.24 10.7866 26.88 10.7866 27.2666 11.1733C27.6533 11.56 27.6533 12.2 27.2666 12.5866L18.5733 21.28C17.8933 21.96 16.9733 22.3466 16 22.3466C15.0266 22.3466 14.1066 21.9733 13.4266 21.28L4.73331 12.5866C4.54664 12.3866 4.43997 12.1333 4.43997 11.88Z"/>
        </svg>
    )
}

export default ArrowBottomTrailerIcon;